import { gql } from '@apollo/client';

export const userLogout = gql`
    query {
      userLogout {
          status
      }
    }
    `;

export const userAccount = `
    query userAccount{
      userAccount {
        userId
        profileId
        firstName
        lastName
        displayName
        gender
        dateOfBirth
        email
        pendingEmailChange
        pendingEmail
        userBanStatus
        phoneNumber
        preferredLanguage
        preferredCurrency
        location
        info
        createdAt
        picture
        country
        countryCode
        countryName
        renterServicePlanAIFeatureStatus
        ownerServicePlanAIFeatureStatus
        verification {
          id
          isEmailConfirmed
          isFacebookConnected
          isGoogleConnected
          isIdVerification
          isPhoneVerified
        }
        userData {
          type
        }
      }
    }
    `;

export const dateAvailability = gql`
    query ($listId:Int!,  $startDate: String!, $endDate: String!) {
      DateAvailability (listId:$listId, startDate:$startDate, endDate: $endDate) {
        status
      }
      }
    `;

export const deleteUser = gql`
    mutation deleteUser ($userId:String!, $userType:String) {
        deleteUser (userId:$userId, userType:$userType) {
          status
          errorMessage
        }
      }
    `;

export const showUserProfile = gql`
    query($profileId: Int) {
        showUserProfile(profileId: $profileId) {
            userId
            profileId
            firstName
            lastName
            dateOfBirth
            gender
            phoneNumber
            preferredLanguage
            preferredCurrency
            location
            info
            createdAt
            picture
            reviewsCount
            country
            countryName
            countryCode
            profileBanStatus{
            email
          }
             userVerifiedInfo{
                isEmailConfirmed
                isIdVerification
                isGoogleConnected
                isFacebookConnected
                isPhoneVerified
 
              }
         }
     }
 `;
export const updateEditProfileInfo = gql`
     mutation updateEditProfileInfo(
          $profileId:Int,
          $firstName:String,
          $lastName:String,
          $gender:String,
          $dateOfBirth:String,
          $location:String,
          $info:String,
          $phoneNumber:String,
          $countryName:String,
          $countryCode:String
          ){
              updateEditProfileInfo(
              profileId:$profileId,
              firstName:$firstName,
              lastName:$lastName,
              gender:$gender,
              dateOfBirth:$dateOfBirth,
              location:$location,
              info:$info,
              phoneNumber:$phoneNumber,
              countryName:$countryName,
              countryCode:$countryCode
              ){
                 status
              }
            }
 `;

export const UploadProfilePicture = gql`
     mutation UploadProfilePicture($picture: String!,$userId:String){
         UploadProfilePicture(picture: $picture,userId:$userId) {      
              status
         }
     }
 `;

export const RemoveProfilePicture = gql`
     mutation RemoveProfilePicture($userId:String){
          RemoveProfilePicture(userId:$userId) {
              status
         }
     }
 `;
export const userEditProfile = `
     query (
     $firstName:String,
     $lastName:String,
     $gender: String,
     $dateOfBirth: String,
     $email: String!,
     $phoneNumber: String,
     $preferredLanguage: String,
     $preferredCurrency: String,
     $location: String,
     $info: String,
     $loggedinEmail: String,
     $countryCode: String,
     $countryName: String,
   ) {
       userEditProfile (
         firstName:$firstName,
         lastName:$lastName,
         gender: $gender,
         dateOfBirth: $dateOfBirth,
         email: $email,
         phoneNumber: $phoneNumber,
         preferredLanguage: $preferredLanguage,
         preferredCurrency: $preferredCurrency,
         location: $location,
         info: $info,
         loggedinEmail: $loggedinEmail,
         countryCode: $countryCode,
         countryName: $countryName,
       ) {
         status
       }
     }
 `;

export const requestEmailChange = `
  mutation requestEmailChange($newEmail: String!) {
    requestEmailChange(newEmail: $newEmail) {
      status
      email
      errorMessage
    }
  }
`;
export const user_Account = gql`
     query {
         userAccount {
             picture
         }
     }
 `;

export const userBanStatusQuery = gql`
 query getUserBanStatus{
  getUserBanStatus {
    status
    userBanStatus
  }
}`;

export const userStatusQuery = gql`
 query getUserStatus{
  getUserStatus {
    status
    userStatus
  }
}`;

export const checkUserStatusQuery = gql`
 query getCheckUserStatus{
  getCheckUserStatus {
    status
    userExistStatus
  }
}`;
